
import { Button, Input, Loader, Paragraph } from '@aaa/muse-ds'
import React, { useState } from 'react';
import ReCAPTCHA from "react-google-recaptcha";
import PropTypes from 'prop-types';
import { sendHertzGoldData } from '../services/sharedservices.service';
import { logCustomEvent } from '../utils/logging.utils';

const RECAPTCHA_KEY = process.env.REACT_APP_RECAPTCHA_KEY

function SubmissionFormComponent(props) {

  const [hertzGoldPlusRewards, setHertzGoldPlusRewards] = useState("")
  const [membershipNumber, setMembershipNumber] = useState("")
  const [postalCode, setPostalCode] = useState("")
  const [feedback, setFeedback] = useState("")
  const [validating, setValidating] = useState(false)
  const recaptchaRef = React.useRef();

  const validateForm = () => {
    setValidating(true);
    props.onError(null)
    recaptchaRef.current.execute()
  }

  const recaptchaOnChange = (recaptchaToken) => {

    logCustomEvent("Hertz",window.location.hostname, "Hertz Premier Gold", "Hertz Premier Gold Submit","Submit",{hertzGoldPlusRewards});

    sendHertzGoldData(recaptchaToken, hertzGoldPlusRewards, membershipNumber, postalCode)
      .then((data)=>{
        logCustomEvent("Hertz",window.location.hostname, "Hertz Premier Gold", "Hertz Premier Gold Submit","Submit Success",{hertzGoldPlusRewards});
          props.onSuccess(data)
      }) .catch((data)=>{
        logCustomEvent("Hertz",window.location.hostname, "Hertz Premier Gold", "Hertz Premier Gold Submit","Submit Error",{hertzGoldPlusRewards});
        props.onError(data)
      }).finally(() => {

        // We are done validating
        setValidating(false);
      })
  }

  const recaptchaError = () => {

    // We are done validating
    setValidating(false);

    // Send back an error
    props.onError("Either the AAA Membership Number was entered incorrectly or is not a AAA Premier account. Please try again or call your AAA office to upgrade to Premier.")

  }
  const resetForm = () => {

    // Reset all fields
    setPostalCode("")
    setMembershipNumber("")
    setHertzGoldPlusRewards("")

    // Send back an empty error
    props.onError(null)
  }

  const updateValidationFeedback = () => {

    setFeedback("")

  }

  const validatingAnimationElement = <span style={{ position: 'absolute', left: "50%", top: "50%", marginLeft: -15, marginTop: -15, zIndex: 1000 }}>
    <Loader></Loader>
  </span>;

  return <div style={{ position: 'relative' }}>
  <Paragraph>
  AAA Premier members who already have a Hertz Gold Plus Rewards<sup>&reg;</sup> membership can now UPGRADE to Five Star<sup>&reg;</sup> status! To upgrade your existing Hertz Gold Plus Rewards to Five Star status, fill in the required information.^
  </Paragraph>


    {/* Optionally show the loading animation when validating */}
    {validating ? validatingAnimationElement : null}
    <div style={{ opacity: validating ? 0.5 : 1 }}>
      <Input
        Input={{
          state: 'INPUT_DEFAULT'
        }}
        max={"16"}
        name="gpr"
        id="grp"
        label="Hertz Gold Plus Rewards Number"
        hideLabel
        value={hertzGoldPlusRewards}
        onChange={(e) => setHertzGoldPlusRewards(e.target.value)}
        onKeyDown={(e) => setHertzGoldPlusRewards(e.target.value)}
        onInput={() => updateValidationFeedback()}
        placeholder="Enter Hertz Gold Plus Rewards Number"
        type="text"
      />
      <Paragraph spacing>Forgot your Gold #, Call Hertz at 888-999-4900, Opt.4</Paragraph>
      <Input
        Input={{
          state: 'INPUT_DEFAULT'
        }}
        max={"16"}
        hideLabel
        label="AAA Membership Number"
        id="membershipNumber"
        name="membershipNumber"
        value={membershipNumber}
        onChange={(e) => { setMembershipNumber(e.target.value); updateValidationFeedback(); }}
        onKeyDown={(e) => { setMembershipNumber(e.target.value); updateValidationFeedback(); }}
        placeholder="Enter 16-digit AAA Membership Number"
        type="text"
      />
      <Input
        Input={{
          state: 'INPUT_DEFAULT'
        }}
        name="postalCode"
        id="postalCode"
        hideLabel
        label="Zip/Postal Code"
        value={postalCode}
        onChange={(e) => { setPostalCode(e.target.value); updateValidationFeedback(); }}
        onKeyDown={(e) => { setPostalCode(e.target.value); updateValidationFeedback(); }}
        onInput={() => updateValidationFeedback()}
        placeholder="Enter Zip/Postal Code"
        type="text"
      />
      <ReCAPTCHA ref={recaptchaRef} onChange={recaptchaOnChange} onErrored={recaptchaError} size="invisible" sitekey={RECAPTCHA_KEY} />
      <p>{feedback}</p>
      <Button color="RED" disabled={validating} action={resetForm}>Reset</Button>
      <Button disabled={validating} action={validateForm}> {validating ? "Validating..." : "Submit"}</Button>
      <br/><br/>
      <Paragraph spacing fontSize="XS">^By clicking submit above, you agree to have the AAA Corporate Discount Program code added as your primary benefit code on your Gold profile. Upgrades will be processed within 45 days.</Paragraph>
    </div>
  </div>
}

SubmissionFormComponent.propTypes = {
  onError: PropTypes.func,
  onSuccess: PropTypes.func
}
export default SubmissionFormComponent;
